import { render, staticRenderFns } from "./PictureTable.vue?vue&type=template&id=053c64eb&scoped=true&lang=pug"
import script from "./PictureTable.vue?vue&type=script&lang=ts"
export * from "./PictureTable.vue?vue&type=script&lang=ts"
import style0 from "./PictureTable.vue?vue&type=style&index=0&id=053c64eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c64eb",
  null
  
)

export default component.exports